import styled from "styled-components"

import { colors, colorScale, spacing } from "@minuthq/meatball-ui-react"
import { format } from "date-fns"

import {
  SCHEDULER_DATE_FORMATS,
  THeaderDateCellProps,
} from "src/ui/Scheduler/schedulerTypes"

export function HeaderDateCell({
  date,
  viewType,
  isCurrentPeriod,
  onDateClick,
  currentPeriodBackground,
  currentPeriodBorderColor,
  currentPeriodTextColor,
  currentPeriodBorderRadius,
}: THeaderDateCellProps) {
  const textColor = isCurrentPeriod ? colors.textPrimary : colors.textTertiary

  const headerStyles = {
    $currentPeriodBackground: currentPeriodBackground,
    $currentPeriodBorderColor: currentPeriodBorderColor,
    $currentPeriodTextColor: currentPeriodTextColor,
    $currentPeriodBorderRadius: currentPeriodBorderRadius,
  }

  if (viewType === "week" || viewType === "month") {
    return (
      <StyledHeader
        $color={textColor}
        $isCurrentPeriod={isCurrentPeriod}
        onClick={() => onDateClick?.(date)}
        {...headerStyles}
      >
        <div>{format(date, SCHEDULER_DATE_FORMATS.WEEK_DAY)}</div>
        <div>{format(date, SCHEDULER_DATE_FORMATS.DAY_MONTH)}</div>
      </StyledHeader>
    )
  }

  return (
    <StyledHeader
      $color={textColor}
      $isCurrentPeriod={isCurrentPeriod}
      onClick={() => onDateClick?.(date)}
      {...headerStyles}
    >
      <div>{format(date, SCHEDULER_DATE_FORMATS.MONTH)}</div>
      <div>{format(date, SCHEDULER_DATE_FORMATS.YEAR)}</div>
    </StyledHeader>
  )
}

const StyledHeader = styled.div<{
  $isCurrentPeriod: boolean
  $color: string
  $currentPeriodBackground?: string
  $currentPeriodBorderColor?: string
  $currentPeriodTextColor?: string
  $currentPeriodBorderRadius?: number
}>`
  background: ${({
    $isCurrentPeriod,
    $currentPeriodBackground: currentPeriodBackground,
  }) => ($isCurrentPeriod ? currentPeriodBackground : "transparent")};
  border: ${({
    $isCurrentPeriod,
    $currentPeriodBorderColor: currentPeriodBorderColor,
  }) => ($isCurrentPeriod ? `1px solid ${currentPeriodBorderColor}` : "none")};
  border-bottom: none;
  margin: 0 0 0 -1px;
  padding: ${spacing.XS};
  border-top-left-radius: ${({
    $isCurrentPeriod,
    $currentPeriodBorderRadius,
  }) => ($isCurrentPeriod ? $currentPeriodBorderRadius : 0)}px;
  border-top-right-radius: ${({
    $isCurrentPeriod,
    $currentPeriodBorderRadius,
  }) => ($isCurrentPeriod ? $currentPeriodBorderRadius : 0)}px;
  color: ${({ $isCurrentPeriod, $currentPeriodTextColor }) =>
    $isCurrentPeriod ? $currentPeriodTextColor : colorScale.clarity[800]};
  font-weight: 600;
  font-size: 14px;
`
